export function getUploadDocumentFileTypes () {
  return window.UP_DOC_FILE_TYPES.split(';')
}
